export default __webpack_public_path__ + "static/media/reactlogo.73c4bc67.png";